// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import ReloadOutlinedSvg from "@ant-design/icons-svg/lib/asn/ReloadOutlined";
import AntdIcon from "../components/AntdIcon";
const ReloadOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: ReloadOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    ReloadOutlined.displayName = "ReloadOutlined";
}
export default /*#__PURE__*/ React.forwardRef(ReloadOutlined);
